"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridLabel = void 0;
const grid_js_1 = require("@ngageoint/grid-js");
/**
 * MGRS Grid Label
 */
class GridLabel extends grid_js_1.Label {
    /**
     * Constructor
     *
     * @param name
     *            name
     * @param center
     *            center point
     * @param bounds
     *            bounds
     * @param gridType
     *            grid type
     * @param coordinate
     *            MGRS coordinate
     */
    constructor(name, center, bounds, gridType, coordinate) {
        super(name, center, bounds);
        this.gridType = gridType;
        this.coordinate = coordinate;
    }
    /**
     * Get the grid type
     *
     * @return grid type
     */
    getGridType() {
        return this.gridType;
    }
    /**
     * Set the grid type
     *
     * @param gridType
     *            grid type
     */
    setGridType(gridType) {
        this.gridType = gridType;
    }
    /**
     * Get the MGRS coordinate
     *
     * @return MGRS coordinate
     */
    getCoordinate() {
        return this.coordinate;
    }
    /**
     * Set the MGRS coordinate
     *
     * @param coordinate
     *            MGRS coordinate
     */
    setCoordinate(coordinate) {
        this.coordinate = coordinate;
    }
}
exports.GridLabel = GridLabel;
//# sourceMappingURL=GridLabel.js.map